import { startSsoRedirect } from "@src/appV2/Auth/OktaSso/startSsoRedirect";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useTu } from "@src/appV2/i18n/useTu";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { useCallback } from "react";

type OktaSsoSource = "submit" | "sso_button";

interface UseOktaSsoLoginResult {
  isOktaSsoEnabled: boolean;
  handleOktaSsoRedirect: (source: OktaSsoSource) => Promise<void>;
}

export function useOktaSsoLogin(): UseOktaSsoLoginResult {
  const { tu } = useTu("login");
  const isOktaSsoEnabled = useCbhFlag(CbhFeatureFlag.ENABLE_OKTA_SSO, { defaultValue: false });

  const handleOktaSsoRedirect = useCallback(
    async (source: OktaSsoSource) => {
      try {
        const requestedURL = localStorage.getItem("redirectURL") ?? undefined;
        await startSsoRedirect(requestedURL, { source });
      } catch (error) {
        logError(APP_V2_APP_EVENTS.OKTA_SSO_REDIRECT_FAILURE, { error });
        showErrorToast(tu("Unable to start Okta sign-in. Please try again."));
      }
    },
    [tu]
  );

  return { isOktaSsoEnabled, handleOktaSsoRedirect };
}
